import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { markIntroSeen, shouldShowIntro, useTheme } from '../theme/ThemeContext';
import './styles/SeasonalIntro.css';

const COPY = {
  school_year: {
    eyebrow: 'Расписание',
    title: 'С началом учебного года!',
    text: 'Пусть этот год будет ярким, спокойным и успешным. Мы рядом с расписанием каждый день.',
    icon: 'bi-mortarboard-fill',
  },
  snow: {
    eyebrow: 'Расписание',
    title: 'С первым снегом!',
    text: 'Пусть зима будет тёплой внутри — а снаружи пусть кружится первый снег.',
    icon: 'bi-snow2',
  },
};

const SeasonalIntro = () => {
  const { theme, activatedAt, ready } = useTheme();
  const [open, setOpen] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    if (!ready) return undefined;
    if (!shouldShowIntro(theme, activatedAt)) {
      setOpen(false);
      return undefined;
    }

    const showTimer = window.setTimeout(() => setOpen(true), 420);
    return () => window.clearTimeout(showTimer);
  }, [theme, activatedAt, ready]);

  useEffect(() => {
    if (!open) return undefined;
    const auto = window.setTimeout(() => dismiss(), 5200);
    return () => window.clearTimeout(auto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    document.body.classList.add('kkt-dialog-open');
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.classList.remove('kkt-dialog-open');
      document.body.style.overflow = prev;
    };
  }, [open]);

  const dismiss = () => {
    if (leaving || !open) return;
    setLeaving(true);
    markIntroSeen(theme, activatedAt);
    window.setTimeout(() => {
      setOpen(false);
      setLeaving(false);
    }, 420);
  };

  if (!open || !COPY[theme] || typeof document === 'undefined') return null;

  const copy = COPY[theme];

  return createPortal(
    <div
      className={`seasonal-intro theme-${theme}${leaving ? ' is-leaving' : ''}`}
      role="dialog"
      aria-modal="true"
      aria-label={copy.title}
      onClick={dismiss}
    >
      <div className="seasonal-intro__veil" aria-hidden="true" />
      <div
        className="seasonal-intro__card"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="seasonal-intro__burst" aria-hidden="true" />
        <div className="seasonal-intro__icon" aria-hidden="true">
          <i className={`bi ${copy.icon}`} />
        </div>
        <p className="seasonal-intro__eyebrow">{copy.eyebrow}</p>
        <h2 className="seasonal-intro__title">{copy.title}</h2>
        <p className="seasonal-intro__text">{copy.text}</p>
        <button type="button" className="seasonal-intro__btn" onClick={dismiss}>
          Продолжить
        </button>
      </div>
    </div>,
    document.body,
  );
};

export default SeasonalIntro;
